/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: Dlxm4vvfq1tf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FeaturesProductHeader from "../../FeaturesProductHeader"; // plasmic-import: nCl4kJqd_uCB/component
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesCard from "../../FeaturesCard"; // plasmic-import: eBFTaYn0ldI-/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component

import { useScreenVariants as useScreenVariantsgibwEjXEmhF1 } from "./PlasmicGlobalVariant__Mobile"; // plasmic-import: GIBWEjXEmhF1/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFeaturesMyEvaluations.module.css"; // plasmic-import: Dlxm4vvfq1tf/css

import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon

createPlasmicElementProxy;

export type PlasmicFeaturesMyEvaluations__VariantMembers = {};
export type PlasmicFeaturesMyEvaluations__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesMyEvaluations__VariantsArgs;
export const PlasmicFeaturesMyEvaluations__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFeaturesMyEvaluations__ArgsType = {};
type ArgPropType = keyof PlasmicFeaturesMyEvaluations__ArgsType;
export const PlasmicFeaturesMyEvaluations__ArgProps = new Array<ArgPropType>();

export type PlasmicFeaturesMyEvaluations__OverridesType = {
  myEvaluations?: Flex__<"section">;
  desktop?: Flex__<"div">;
  row?: Flex__<"div">;
  logo?: Flex__<typeof Logo>;
  key2?: Flex__<"div">;
  header?: Flex__<"header">;
  list?: Flex__<"div">;
  row2?: Flex__<"div">;
  row3?: Flex__<"div">;
  row4?: Flex__<"div">;
  row5?: Flex__<"div">;
  all?: Flex__<"div">;
  title?: Flex__<"h2">;
  sections?: Flex__<"div">;
  col2?: Flex__<"div">;
  list2?: Flex__<"div">;
  col3?: Flex__<"div">;
  section?: Flex__<"div">;
  list3?: Flex__<"div">;
  section2?: Flex__<"div">;
  list4?: Flex__<"div">;
  col4?: Flex__<"div">;
  list5?: Flex__<"div">;
  tablet?: Flex__<"div">;
  row6?: Flex__<"div">;
  key4?: Flex__<"div">;
  header4?: Flex__<"header">;
  list11?: Flex__<"div">;
  row7?: Flex__<"div">;
  row8?: Flex__<"div">;
  row9?: Flex__<"div">;
  row10?: Flex__<"div">;
  row11?: Flex__<"div">;
  all3?: Flex__<"div">;
  title3?: Flex__<"h2">;
  sections3?: Flex__<"div">;
  col8?: Flex__<"div">;
  list12?: Flex__<"div">;
  col9?: Flex__<"div">;
  section5?: Flex__<"div">;
  list13?: Flex__<"div">;
  section6?: Flex__<"div">;
  list14?: Flex__<"div">;
  col10?: Flex__<"div">;
  list15?: Flex__<"div">;
  mobile?: Flex__<"div">;
  header3?: Flex__<"div">;
  key3?: Flex__<"div">;
  header2?: Flex__<"header">;
  list6?: Flex__<"div">;
  all2?: Flex__<"div">;
  title2?: Flex__<"h2">;
  sections2?: Flex__<"div">;
  col5?: Flex__<"div">;
  list7?: Flex__<"div">;
  col6?: Flex__<"div">;
  section3?: Flex__<"div">;
  list8?: Flex__<"div">;
  section4?: Flex__<"div">;
  list9?: Flex__<"div">;
  col7?: Flex__<"div">;
  list10?: Flex__<"div">;
};

export interface DefaultFeaturesMyEvaluationsProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesMyEvaluations__RenderFunc(props: {
  variants: PlasmicFeaturesMyEvaluations__VariantsArgs;
  args: PlasmicFeaturesMyEvaluations__ArgsType;
  overrides: PlasmicFeaturesMyEvaluations__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = ensureGlobalVariants({
    mobile: useScreenVariantsgibwEjXEmhF1()
  });

  return (
    <Stack__
      as={"section"}
      data-plasmic-name={"myEvaluations"}
      data-plasmic-override={overrides.myEvaluations}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.myEvaluations
      )}
      id={"MyEvaluations"}
    >
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <PlasmicImg__
          alt={""}
          className={classNames(sty.img__pAi5O)}
          displayHeight={"527px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1770px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/67f04ddfb024c31590f097503108861e.svg",
            fullWidth: 1770,
            fullHeight: 527,
            aspectRatio: 3.358634
          }}
        />
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
          ? false
          : true
      ) ? (
        <Stack__
          as={"div"}
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          hasGap={true}
          className={classNames(projectcss.all, sty.desktop)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            hasGap={true}
            className={classNames(projectcss.all, sty.row)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__uSqkg
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                data-plasmic-name={"logo"}
                data-plasmic-override={overrides.logo}
                className={classNames("__wab_instance", sty.logo)}
                product={"myEvaluations"}
              />
            </FeaturesProductHeader>
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"key2"}
            data-plasmic-override={overrides.key2}
            hasGap={true}
            className={classNames(projectcss.all, sty.key2)}
          >
            <header
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              className={classNames(projectcss.all, sty.header)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2___92Hls
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <Stack__
              as={"div"}
              data-plasmic-name={"list"}
              data-plasmic-override={overrides.list}
              hasGap={true}
              className={classNames(projectcss.all, sty.list)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"row2"}
                data-plasmic-override={overrides.row2}
                hasGap={true}
                className={classNames(projectcss.all, sty.row2)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__gYmKq
                  )}
                  desciption={
                    "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                  }
                  title={"Evaluations, Milestones & EPAs"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__jDttS)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___74Wv2
                  )}
                  desciption={
                    "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                  }
                  title={
                    "Performance Improvement Plans & Clinical Learning Contracts"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__quc19)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e7ed370b68c67f76e2ca004000c2ffc7.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__jUs1H
                  )}
                  desciption={
                    "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                  }
                  title={"Curriculum Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__qsMQp)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/cb0239402e2936b1bf7362398e69386b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row3"}
                data-plasmic-override={overrides.row3}
                hasGap={true}
                className={classNames(projectcss.all, sty.row3)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__avF8
                  )}
                  desciption={
                    "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                  }
                  title={"Educational Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__wXnn2)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/1f79a4c37de0c595115ccbeec901b877.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__g3HJb
                  )}
                  desciption={
                    "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                  }
                  title={"ACGME Compliance Tracking"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__eYfc)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e0f7df98d28ee45e44aa7bee3fa42fa0.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___0PREf
                  )}
                  desciption={
                    "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                  }
                  title={"Administrative Tools"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___8A12H)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a46f0a440808da7c0237c86d05dd281c.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row4"}
                data-plasmic-override={overrides.row4}
                hasGap={true}
                className={classNames(projectcss.all, sty.row4)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__cGbli
                  )}
                  desciption={
                    "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                  }
                  title={"Procedure & Patient Logging"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__or2A9)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/f84f25cdb0e594e6d5e5dd86882a0815.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__iKKzg
                  )}
                  desciption={
                    "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                  }
                  title={"Scheduling & Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__xLsj)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/8debbf898d018ca00021c1aa8e2fa91b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__jzGAk
                  )}
                  desciption={
                    "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                  }
                  title={"MyQuiz & Learning Assignments"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___8JUpx)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a3ca4aac0456c9eddccb298b95e5d36b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row5"}
                data-plasmic-override={overrides.row5}
                hasGap={true}
                className={classNames(projectcss.all, sty.row5)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__edfbY
                  )}
                  desciption={
                    "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                  }
                  title={"Return Demonstrations"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__jBfHt)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <div
                  className={classNames(projectcss.all, sty.freeBox__nAu3T)}
                />

                <div
                  className={classNames(projectcss.all, sty.freeBox__oWMqw)}
                />
              </Stack__>
            </Stack__>
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"all"}
            data-plasmic-override={overrides.all}
            hasGap={true}
            className={classNames(projectcss.all, sty.all)}
          >
            <h2
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Full Feature List"}
            </h2>
            <Stack__
              as={"div"}
              data-plasmic-name={"sections"}
              data-plasmic-override={overrides.sections}
              hasGap={true}
              className={classNames(projectcss.all, sty.sections)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                hasGap={true}
                className={classNames(projectcss.all, sty.col2)}
              >
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__z1Q2Q
                  )}
                >
                  {"All Use Cases"}
                </h3>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"list2"}
                  data-plasmic-override={overrides.list2}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.list2)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Evaluations/Assessments"
                          },
                          {
                            text: "MyInsight"
                          },
                          {
                            text: "Milestones & EPAs"
                          },
                          {
                            text: "Narrative Predictive Value (NPV)"
                          },
                          {
                            text: "Performance Improvement Plans"
                          },
                          {
                            text: "Clinical Hours (Duty-Hours)"
                          },
                          {
                            text: "MyQuickPass"
                          },
                          {
                            text: "Conference Tracking"
                          },
                          {
                            text: "Burnout Monitoring"
                          },
                          {
                            text: "EHR Connectivity"
                          },
                          {
                            text: "Clinical Log (3rd Party) Integration"
                          },
                          {
                            text: "Learning Assignments"
                          },
                          {
                            text: "MyQuiz (Quizzes/Exams)"
                          },
                          {
                            text: "Demographic Management"
                          },
                          {
                            text: "Onboarding & Credentialing"
                          },
                          {
                            text: "Certificate/Diploma Management"
                          },
                          {
                            text: "Schedule Management"
                          },
                          {
                            text: "Automatic Scheduling & Lottery"
                          },
                          {
                            text: "Schedule (3rd Party) Integration"
                          },
                          {
                            text: "MyPortfolios"
                          },
                          {
                            text: "Performance Dashboard"
                          },
                          {
                            text: "Custom Reporting"
                          },
                          {
                            text: "Electronic Contracts & Signatures"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__s0JrT
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__d6BLf)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </Stack__>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"col3"}
                data-plasmic-override={overrides.col3}
                hasGap={true}
                className={classNames(projectcss.all, sty.col3)}
              >
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section"}
                  data-plasmic-override={overrides.section}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__iYtoH
                    )}
                  >
                    {"GME & Physician Assistant Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list3"}
                    data-plasmic-override={overrides.list3}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list3)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Curriculum Management"
                            },
                            {
                              text: "Procedure Logging"
                            },
                            {
                              text: "Patient Logging"
                            },
                            {
                              text: "Centralized Procedure Reporting"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__qi46W
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__m83Du
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section2"}
                  data-plasmic-override={overrides.section2}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section2)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__uTCh
                    )}
                  >
                    {"GME Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list4"}
                    data-plasmic-override={overrides.list4}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list4)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Annual Program Evaluations"
                            },
                            {
                              text: "Common Program Requirements"
                            },
                            {
                              text: "Institutional Requirements"
                            },
                            {
                              text: "Take Action Plans & Notifications"
                            },
                            {
                              text: "ERAS Data Importing"
                            },
                            {
                              text: "Electronic Contract Management"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__e9Igb
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__ipQ7X
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"col4"}
                data-plasmic-override={overrides.col4}
                hasGap={true}
                className={classNames(projectcss.all, sty.col4)}
              >
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__rh3Ts
                  )}
                >
                  {"Nursing Programs"}
                </h3>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"list5"}
                  data-plasmic-override={overrides.list5}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.list5)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Clinical Activity Logger"
                          },
                          {
                            text: "Return Demonstration Management"
                          },
                          {
                            text: "Return Demonstration Testing"
                          },
                          {
                            text: "Clinical Learning Contracts"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__hHnHp
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(
                            projectcss.all,
                            sty.svg___1Ohbo
                          )}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </Stack__>
              </Stack__>
            </Stack__>
          </Stack__>
        </Stack__>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? false
          : hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
          ? true
          : false
      ) ? (
        <Stack__
          as={"div"}
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          hasGap={true}
          className={classNames(projectcss.all, sty.tablet)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            hasGap={true}
            className={classNames(projectcss.all, sty.row6)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__iwmYt
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            />
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"key4"}
            data-plasmic-override={overrides.key4}
            hasGap={true}
            className={classNames(projectcss.all, sty.key4)}
          >
            <header
              data-plasmic-name={"header4"}
              data-plasmic-override={overrides.header4}
              className={classNames(projectcss.all, sty.header4)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2__ce5Z
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <Stack__
              as={"div"}
              data-plasmic-name={"list11"}
              data-plasmic-override={overrides.list11}
              hasGap={true}
              className={classNames(projectcss.all, sty.list11)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"row7"}
                data-plasmic-override={overrides.row7}
                hasGap={true}
                className={classNames(projectcss.all, sty.row7)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__fC8Vq
                  )}
                  desciption={
                    "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                  }
                  title={"Evaluations, Milestones & EPAs"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__jI6DX)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__zVqmg
                  )}
                  desciption={
                    "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                  }
                  title={
                    "Performance Improvement Plans & Clinical Learning Contracts"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__c37A5)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e7ed370b68c67f76e2ca004000c2ffc7.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row8"}
                data-plasmic-override={overrides.row8}
                hasGap={true}
                className={classNames(projectcss.all, sty.row8)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__uCaG0
                  )}
                  desciption={
                    "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                  }
                  title={"Curriculum Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__nKmWd)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/cb0239402e2936b1bf7362398e69386b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sGPsZ
                  )}
                  desciption={
                    "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                  }
                  title={"Educational Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__fefGs)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/1f79a4c37de0c595115ccbeec901b877.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row9"}
                data-plasmic-override={overrides.row9}
                hasGap={true}
                className={classNames(projectcss.all, sty.row9)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__bLCm
                  )}
                  desciption={
                    "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                  }
                  title={"ACGME Compliance Tracking"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__z8Ch9)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e0f7df98d28ee45e44aa7bee3fa42fa0.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__vaM1N
                  )}
                  desciption={
                    "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                  }
                  title={"Administrative Tools"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__a0Q6U)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a46f0a440808da7c0237c86d05dd281c.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row10"}
                data-plasmic-override={overrides.row10}
                hasGap={true}
                className={classNames(projectcss.all, sty.row10)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__gmAGe
                  )}
                  desciption={
                    "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                  }
                  title={"Procedure & Patient Logging"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__uc4M)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/f84f25cdb0e594e6d5e5dd86882a0815.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__oUyx7
                  )}
                  desciption={
                    "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                  }
                  title={"Scheduling & Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___4HgYp)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/8debbf898d018ca00021c1aa8e2fa91b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"row11"}
                data-plasmic-override={overrides.row11}
                hasGap={true}
                className={classNames(projectcss.all, sty.row11)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sjuMb
                  )}
                  desciption={
                    "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                  }
                  title={"MyQuiz & Learning Assignments"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__cSkFn)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a3ca4aac0456c9eddccb298b95e5d36b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__vAnz3
                  )}
                  desciption={
                    "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                  }
                  title={"Return Demonstrations"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__lnPh)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </Stack__>
            </Stack__>
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"all3"}
            data-plasmic-override={overrides.all3}
            hasGap={true}
            className={classNames(projectcss.all, sty.all3)}
          >
            <h2
              data-plasmic-name={"title3"}
              data-plasmic-override={overrides.title3}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title3
              )}
            >
              {"Full Feature List"}
            </h2>
            <Stack__
              as={"div"}
              data-plasmic-name={"sections3"}
              data-plasmic-override={overrides.sections3}
              hasGap={true}
              className={classNames(projectcss.all, sty.sections3)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"col8"}
                data-plasmic-override={overrides.col8}
                hasGap={true}
                className={classNames(projectcss.all, sty.col8)}
              >
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3___8LOD
                  )}
                >
                  {"All Use Cases"}
                </h3>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"list12"}
                  data-plasmic-override={overrides.list12}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.list12)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Evaluations/Assessments"
                          },
                          {
                            text: "MyInsight"
                          },
                          {
                            text: "Milestones & EPAs"
                          },
                          {
                            text: "Narrative Predictive Value (NPV)"
                          },
                          {
                            text: "Performance Improvement Plans"
                          },
                          {
                            text: "Clinical Hours (Duty-Hours)"
                          },
                          {
                            text: "MyQuickPass"
                          },
                          {
                            text: "Conference Tracking"
                          },
                          {
                            text: "Burnout Monitoring"
                          },
                          {
                            text: "EHR Connectivity"
                          },
                          {
                            text: "Clinical Log (3rd Party) Integration"
                          },
                          {
                            text: "Learning Assignments"
                          },
                          {
                            text: "MyQuiz (Quizzes/Exams)"
                          },
                          {
                            text: "Demographic Management"
                          },
                          {
                            text: "Onboarding & Credentialing"
                          },
                          {
                            text: "Certificate/Diploma Management"
                          },
                          {
                            text: "Schedule Management"
                          },
                          {
                            text: "Automatic Scheduling & Lottery"
                          },
                          {
                            text: "Schedule (3rd Party) Integration"
                          },
                          {
                            text: "MyPortfolios"
                          },
                          {
                            text: "Performance Dashboard"
                          },
                          {
                            text: "Custom Reporting"
                          },
                          {
                            text: "Electronic Contracts & Signatures"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__kOb7B
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__eh4F0)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </Stack__>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"col9"}
                data-plasmic-override={overrides.col9}
                hasGap={true}
                className={classNames(projectcss.all, sty.col9)}
              >
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section5"}
                  data-plasmic-override={overrides.section5}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section5)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__fFril
                    )}
                  >
                    {"GME & Physician Assistant Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list13"}
                    data-plasmic-override={overrides.list13}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list13)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Curriculum Management"
                            },
                            {
                              text: "Procedure Logging"
                            },
                            {
                              text: "Patient Logging"
                            },
                            {
                              text: "Centralized Procedure Reporting"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__ubL2C
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__uVLlA
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section6"}
                  data-plasmic-override={overrides.section6}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section6)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3___25Gvl
                    )}
                  >
                    {"GME Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list14"}
                    data-plasmic-override={overrides.list14}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list14)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Annual Program Evaluations"
                            },
                            {
                              text: "Common Program Requirements"
                            },
                            {
                              text: "Institutional Requirements"
                            },
                            {
                              text: "Take Action Plans & Notifications"
                            },
                            {
                              text: "ERAS Data Importing"
                            },
                            {
                              text: "Electronic Contract Management"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__omYwO
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__huE4
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"col10"}
                  data-plasmic-override={overrides.col10}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.col10)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__dZhp7
                    )}
                  >
                    {"Nursing Programs"}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list15"}
                    data-plasmic-override={overrides.list15}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list15)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Clinical Activity Logger"
                            },
                            {
                              text: "Return Demonstration Management"
                            },
                            {
                              text: "Return Demonstration Testing"
                            },
                            {
                              text: "Clinical Learning Contracts"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem___9B74C
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__lx5GI
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
              </Stack__>
            </Stack__>
          </Stack__>
        </Stack__>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? true
          : hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : false
      ) ? (
        <Stack__
          as={"div"}
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          hasGap={true}
          className={classNames(projectcss.all, sty.mobile)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"header3"}
            data-plasmic-override={overrides.header3}
            hasGap={true}
            className={classNames(projectcss.all, sty.header3)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__kawt
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : undefined
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : undefined
              }
            />
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"key3"}
            data-plasmic-override={overrides.key3}
            hasGap={true}
            className={classNames(projectcss.all, sty.key3)}
          >
            <header
              data-plasmic-name={"header2"}
              data-plasmic-override={overrides.header2}
              className={classNames(projectcss.all, sty.header2)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2__jIpFt
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <Stack__
              as={"div"}
              data-plasmic-name={"list6"}
              data-plasmic-override={overrides.list6}
              hasGap={true}
              className={classNames(projectcss.all, sty.list6)}
            >
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__p2CsD
                )}
                desciption={
                  "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                }
                title={"Evaluations, Milestones & EPAs"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__r3Jti)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard___98J5D
                )}
                desciption={
                  "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                }
                title={
                  "Performance Improvement Plans & Clinical Learning Contracts"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gqdH)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/e7ed370b68c67f76e2ca004000c2ffc7.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__mtlYt
                )}
                desciption={
                  "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                }
                title={"Curriculum Management"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__cxHCj)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/cb0239402e2936b1bf7362398e69386b.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__zhf6R
                )}
                desciption={
                  "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                }
                title={"Educational Compliance"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gXyHj)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/1f79a4c37de0c595115ccbeec901b877.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames("__wab_instance", sty.featuresCard__byR6)}
                desciption={
                  "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                }
                title={"ACGME Compliance Tracking"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__rg98L)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/e0f7df98d28ee45e44aa7bee3fa42fa0.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__ou1Ui
                )}
                desciption={
                  "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                }
                title={"Administrative Tools"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ejyy8)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a46f0a440808da7c0237c86d05dd281c.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__byolC
                )}
                desciption={
                  "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                }
                title={"Procedure & Patient Logging"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__xfFl6)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/f84f25cdb0e594e6d5e5dd86882a0815.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__x8VU7
                )}
                desciption={
                  "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                }
                title={"Scheduling & Compliance"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ocSml)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/8debbf898d018ca00021c1aa8e2fa91b.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__o6DZh
                )}
                desciption={
                  "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                }
                title={"MyQuiz & Learning Assignments"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ce31A)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a3ca4aac0456c9eddccb298b95e5d36b.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__i5H57
                )}
                desciption={
                  "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                }
                title={"Return Demonstrations"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__elAeA)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
            </Stack__>
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"all2"}
            data-plasmic-override={overrides.all2}
            hasGap={true}
            className={classNames(projectcss.all, sty.all2)}
          >
            <h2
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title2
              )}
            >
              {"Full Feature List"}
            </h2>
            <Stack__
              as={"div"}
              data-plasmic-name={"sections2"}
              data-plasmic-override={overrides.sections2}
              hasGap={true}
              className={classNames(projectcss.all, sty.sections2)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"col5"}
                data-plasmic-override={overrides.col5}
                hasGap={true}
                className={classNames(projectcss.all, sty.col5)}
              >
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3___3FiT3
                  )}
                >
                  {"All Use Cases"}
                </h3>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"list7"}
                  data-plasmic-override={overrides.list7}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.list7)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Evaluations/Assessments"
                          },
                          {
                            text: "MyInsight"
                          },
                          {
                            text: "Milestones & EPAs"
                          },
                          {
                            text: "Narrative Predictive Value (NPV)"
                          },
                          {
                            text: "Performance Improvement Plans"
                          },
                          {
                            text: "Clinical Hours (Duty-Hours)"
                          },
                          {
                            text: "MyQuickPass"
                          },
                          {
                            text: "Conference Tracking"
                          },
                          {
                            text: "Burnout Monitoring"
                          },
                          {
                            text: "EHR Connectivity"
                          },
                          {
                            text: "Clinical Log (3rd Party) Integration"
                          },
                          {
                            text: "Learning Assignments"
                          },
                          {
                            text: "MyQuiz (Quizzes/Exams)"
                          },
                          {
                            text: "Demographic Management"
                          },
                          {
                            text: "Onboarding & Credentialing"
                          },
                          {
                            text: "Certificate/Diploma Management"
                          },
                          {
                            text: "Schedule Management"
                          },
                          {
                            text: "Automatic Scheduling & Lottery"
                          },
                          {
                            text: "Schedule (3rd Party) Integration"
                          },
                          {
                            text: "MyPortfolios"
                          },
                          {
                            text: "Performance Dashboard"
                          },
                          {
                            text: "Custom Reporting"
                          },
                          {
                            text: "Electronic Contracts & Signatures"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__ygclU
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__go5Tp)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </Stack__>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"col6"}
                data-plasmic-override={overrides.col6}
                hasGap={true}
                className={classNames(projectcss.all, sty.col6)}
              >
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section3"}
                  data-plasmic-override={overrides.section3}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section3)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__mstTe
                    )}
                  >
                    {"GME & Physician Assistant Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list8"}
                    data-plasmic-override={overrides.list8}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list8)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Curriculum Management"
                            },
                            {
                              text: "Procedure Logging"
                            },
                            {
                              text: "Patient Logging"
                            },
                            {
                              text: "Centralized Procedure Reporting"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__vWyV5
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__gc1O7
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"section4"}
                  data-plasmic-override={overrides.section4}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.section4)}
                >
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__keLun
                    )}
                  >
                    {"GME Programs "}
                  </h3>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"list9"}
                    data-plasmic-override={overrides.list9}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.list9)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Annual Program Evaluations"
                            },
                            {
                              text: "Common Program Requirements"
                            },
                            {
                              text: "Institutional Requirements"
                            },
                            {
                              text: "Take Action Plans & Notifications"
                            },
                            {
                              text: "ERAS Data Importing"
                            },
                            {
                              text: "Electronic Contract Management"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem___2FvEa
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__wlrXn
                            )}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </Stack__>
                </Stack__>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"col7"}
                data-plasmic-override={overrides.col7}
                hasGap={true}
                className={classNames(projectcss.all, sty.col7)}
              >
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__vhpfy
                  )}
                >
                  {"Nursing Programs"}
                </h3>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"list10"}
                  data-plasmic-override={overrides.list10}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.list10)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Clinical Activity Logger"
                          },
                          {
                            text: "Return Demonstration Management"
                          },
                          {
                            text: "Return Demonstration Testing"
                          },
                          {
                            text: "Clinical Learning Contracts"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__dnri6
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__kEdGq)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </Stack__>
              </Stack__>
            </Stack__>
          </Stack__>
        </Stack__>
      ) : null}
    </Stack__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  myEvaluations: [
    "myEvaluations",
    "desktop",
    "row",
    "logo",
    "key2",
    "header",
    "list",
    "row2",
    "row3",
    "row4",
    "row5",
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section",
    "list3",
    "section2",
    "list4",
    "col4",
    "list5",
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row9",
    "row10",
    "row11",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15",
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections2",
    "col5",
    "list7",
    "col6",
    "section3",
    "list8",
    "section4",
    "list9",
    "col7",
    "list10"
  ],
  desktop: [
    "desktop",
    "row",
    "logo",
    "key2",
    "header",
    "list",
    "row2",
    "row3",
    "row4",
    "row5",
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section",
    "list3",
    "section2",
    "list4",
    "col4",
    "list5"
  ],
  row: ["row", "logo"],
  logo: ["logo"],
  key2: ["key2", "header", "list", "row2", "row3", "row4", "row5"],
  header: ["header"],
  list: ["list", "row2", "row3", "row4", "row5"],
  row2: ["row2"],
  row3: ["row3"],
  row4: ["row4"],
  row5: ["row5"],
  all: [
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section",
    "list3",
    "section2",
    "list4",
    "col4",
    "list5"
  ],
  title: ["title"],
  sections: [
    "sections",
    "col2",
    "list2",
    "col3",
    "section",
    "list3",
    "section2",
    "list4",
    "col4",
    "list5"
  ],
  col2: ["col2", "list2"],
  list2: ["list2"],
  col3: ["col3", "section", "list3", "section2", "list4"],
  section: ["section", "list3"],
  list3: ["list3"],
  section2: ["section2", "list4"],
  list4: ["list4"],
  col4: ["col4", "list5"],
  list5: ["list5"],
  tablet: [
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row9",
    "row10",
    "row11",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  row6: ["row6"],
  key4: ["key4", "header4", "list11", "row7", "row8", "row9", "row10", "row11"],
  header4: ["header4"],
  list11: ["list11", "row7", "row8", "row9", "row10", "row11"],
  row7: ["row7"],
  row8: ["row8"],
  row9: ["row9"],
  row10: ["row10"],
  row11: ["row11"],
  all3: [
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  title3: ["title3"],
  sections3: [
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  col8: ["col8", "list12"],
  list12: ["list12"],
  col9: ["col9", "section5", "list13", "section6", "list14", "col10", "list15"],
  section5: ["section5", "list13"],
  list13: ["list13"],
  section6: ["section6", "list14"],
  list14: ["list14"],
  col10: ["col10", "list15"],
  list15: ["list15"],
  mobile: [
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections2",
    "col5",
    "list7",
    "col6",
    "section3",
    "list8",
    "section4",
    "list9",
    "col7",
    "list10"
  ],
  header3: ["header3"],
  key3: ["key3", "header2", "list6"],
  header2: ["header2"],
  list6: ["list6"],
  all2: [
    "all2",
    "title2",
    "sections2",
    "col5",
    "list7",
    "col6",
    "section3",
    "list8",
    "section4",
    "list9",
    "col7",
    "list10"
  ],
  title2: ["title2"],
  sections2: [
    "sections2",
    "col5",
    "list7",
    "col6",
    "section3",
    "list8",
    "section4",
    "list9",
    "col7",
    "list10"
  ],
  col5: ["col5", "list7"],
  list7: ["list7"],
  col6: ["col6", "section3", "list8", "section4", "list9"],
  section3: ["section3", "list8"],
  list8: ["list8"],
  section4: ["section4", "list9"],
  list9: ["list9"],
  col7: ["col7", "list10"],
  list10: ["list10"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  myEvaluations: "section";
  desktop: "div";
  row: "div";
  logo: typeof Logo;
  key2: "div";
  header: "header";
  list: "div";
  row2: "div";
  row3: "div";
  row4: "div";
  row5: "div";
  all: "div";
  title: "h2";
  sections: "div";
  col2: "div";
  list2: "div";
  col3: "div";
  section: "div";
  list3: "div";
  section2: "div";
  list4: "div";
  col4: "div";
  list5: "div";
  tablet: "div";
  row6: "div";
  key4: "div";
  header4: "header";
  list11: "div";
  row7: "div";
  row8: "div";
  row9: "div";
  row10: "div";
  row11: "div";
  all3: "div";
  title3: "h2";
  sections3: "div";
  col8: "div";
  list12: "div";
  col9: "div";
  section5: "div";
  list13: "div";
  section6: "div";
  list14: "div";
  col10: "div";
  list15: "div";
  mobile: "div";
  header3: "div";
  key3: "div";
  header2: "header";
  list6: "div";
  all2: "div";
  title2: "h2";
  sections2: "div";
  col5: "div";
  list7: "div";
  col6: "div";
  section3: "div";
  list8: "div";
  section4: "div";
  list9: "div";
  col7: "div";
  list10: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesMyEvaluations__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesMyEvaluations__VariantsArgs;
    args?: PlasmicFeaturesMyEvaluations__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicFeaturesMyEvaluations__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicFeaturesMyEvaluations__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesMyEvaluations__ArgProps,
          internalVariantPropNames: PlasmicFeaturesMyEvaluations__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesMyEvaluations__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "myEvaluations") {
    func.displayName = "PlasmicFeaturesMyEvaluations";
  } else {
    func.displayName = `PlasmicFeaturesMyEvaluations.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesMyEvaluations = Object.assign(
  // Top-level PlasmicFeaturesMyEvaluations renders the root element
  makeNodeComponent("myEvaluations"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    row: makeNodeComponent("row"),
    logo: makeNodeComponent("logo"),
    key2: makeNodeComponent("key2"),
    header: makeNodeComponent("header"),
    list: makeNodeComponent("list"),
    row2: makeNodeComponent("row2"),
    row3: makeNodeComponent("row3"),
    row4: makeNodeComponent("row4"),
    row5: makeNodeComponent("row5"),
    all: makeNodeComponent("all"),
    title: makeNodeComponent("title"),
    sections: makeNodeComponent("sections"),
    col2: makeNodeComponent("col2"),
    list2: makeNodeComponent("list2"),
    col3: makeNodeComponent("col3"),
    section: makeNodeComponent("section"),
    list3: makeNodeComponent("list3"),
    section2: makeNodeComponent("section2"),
    list4: makeNodeComponent("list4"),
    col4: makeNodeComponent("col4"),
    list5: makeNodeComponent("list5"),
    tablet: makeNodeComponent("tablet"),
    row6: makeNodeComponent("row6"),
    key4: makeNodeComponent("key4"),
    header4: makeNodeComponent("header4"),
    list11: makeNodeComponent("list11"),
    row7: makeNodeComponent("row7"),
    row8: makeNodeComponent("row8"),
    row9: makeNodeComponent("row9"),
    row10: makeNodeComponent("row10"),
    row11: makeNodeComponent("row11"),
    all3: makeNodeComponent("all3"),
    title3: makeNodeComponent("title3"),
    sections3: makeNodeComponent("sections3"),
    col8: makeNodeComponent("col8"),
    list12: makeNodeComponent("list12"),
    col9: makeNodeComponent("col9"),
    section5: makeNodeComponent("section5"),
    list13: makeNodeComponent("list13"),
    section6: makeNodeComponent("section6"),
    list14: makeNodeComponent("list14"),
    col10: makeNodeComponent("col10"),
    list15: makeNodeComponent("list15"),
    mobile: makeNodeComponent("mobile"),
    header3: makeNodeComponent("header3"),
    key3: makeNodeComponent("key3"),
    header2: makeNodeComponent("header2"),
    list6: makeNodeComponent("list6"),
    all2: makeNodeComponent("all2"),
    title2: makeNodeComponent("title2"),
    sections2: makeNodeComponent("sections2"),
    col5: makeNodeComponent("col5"),
    list7: makeNodeComponent("list7"),
    col6: makeNodeComponent("col6"),
    section3: makeNodeComponent("section3"),
    list8: makeNodeComponent("list8"),
    section4: makeNodeComponent("section4"),
    list9: makeNodeComponent("list9"),
    col7: makeNodeComponent("col7"),
    list10: makeNodeComponent("list10"),

    // Metadata about props expected for PlasmicFeaturesMyEvaluations
    internalVariantProps: PlasmicFeaturesMyEvaluations__VariantProps,
    internalArgProps: PlasmicFeaturesMyEvaluations__ArgProps
  }
);

export default PlasmicFeaturesMyEvaluations;
/* prettier-ignore-end */
